import React from 'react';

import type { SkeletonNode as ISkeletonNode, WorkflowNodeProps } from 'flow/service/graph';

import BaseNode from '../BaseNode';


function SkeletonNode(props: WorkflowNodeProps<ISkeletonNode>) {
  const { id, type } = props;

  return (
    <BaseNode
      id={id}
      stateStyle={{
        baseBackgroundColor: 'var(--cl-gray-300)',
      }}
      type={type}
    />
  );
}

export default React.memo(SkeletonNode);
